import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import constants from "../constants/constants";
import { useEffect, useState } from "react";
import SEO, { pageSEO } from "../components/seo.component";
import { useUserParams } from "../hooks/useUserParams";

export default function Contact() {
  const {
    getCurrentAgentName,
    getCurrentAgentTitle,
    getCurrentAgentNumber,
    getCurrentAgentEmail,
    getCurrentBrokerage
  } = useUserParams();
  
  const [popup, setPopup] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    "Email Address": "",
    Message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  async function submitForm(event) {
    event.preventDefault();

    const data = {
      ...formData,
      access_key: constants.EMAIL_ACCESS_KEY,
      subject: "New Contact Form Message",
    };

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
      });

      const response = await res.json();

      if (response?.success) {
        console.log("Success", response);
        setPopup({
          subject: "Thanks for your message!",
          message: "We will get back to you as soon as possible",
        });
        // Clear form after successful submission
        setFormData({
          Name: "",
          "Email Address": "",
          Message: "",
        });
      } else {
        setPopup({
          subject: "We encountered an error in sending this message",
          message: "Please try again later",
        });
      }
    } catch (err) {
      console.log(err);
      setPopup({
        subject: "We encountered an error in sending this message",
        message: "Please try again later",
      });
    }
  }

  const [windowSize, setWindowSize] = useState(window.innerWidth);

  const onWindowResize = () => {
    setWindowSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  const seoConfig = pageSEO.contact();
  return (
    <>
      <SEO {...seoConfig} />
      <div className="w-full bg-white pt-[150px] flex flex-wrap gap-x-16 gap-y-10 justify-center py-16 px-7 min-h-[70vh]">
        <div>
          <h4 className=" font-semibold text-black text-lg min-w-[20vw]">
            Questions? I'm Here To Help
          </h4>
          <form onSubmit={submitForm} className="mt-6 flex flex-col">
            <div className="form-item">
              <label className="form-label">Name*</label>
              <input
                className="form-input"
                name="Name"
                placeholder="Full Name"
                value={formData.Name}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-item">
              <label className="form-label">Email*</label>
              <input
                className="form-input"
                name="Email Address"
                placeholder="Email Address"
                value={formData["Email Address"]}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-item">
              <label className="form-label">Message*</label>
              <textarea
                className="form-input resize-none h-32"
                name="Message"
                placeholder="Your Message"
                value={formData.Message}
                onChange={handleInputChange}
              />
            </div>
            <button type="submit" className="btn-tertiary self-start px-10">
              Send
            </button>
          </form>
        </div>
        <div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2885.1670922064877!2d-79.3108446!3d43.686289499999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4cc14ec855631%3A0xb3d0feb68a2d0ed3!2s85%20Cedarvale%20Ave%2C%20Toronto%2C%20ON%20M4C%204J7!5e0!3m2!1sen!2sca!4v1730912488107!5m2!1sen!2sca"
            height="365"
            width={`${windowSize > 900 ? "500" : "300"}`}
            style={{ border: 0 }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>

          <div className="flex flex-col gap-y-2 text-black mt-6">
            <h2 className="text-black text-2xl libre">
              {getCurrentAgentName()}
            </h2>
            <p className="italic">{getCurrentAgentTitle()}, {getCurrentBrokerage()}</p>
            <p>
              <FontAwesomeIcon
                icon={faPhone}
                className="text-logo-second fa-lg"
              />{" "}
              {getCurrentAgentNumber()}{" "}
            </p>
            <p>
              <FontAwesomeIcon
                icon={faEnvelope}
                className="text-logo-second fa-lg"
              />{" "}
              {getCurrentAgentEmail()}{" "}
            </p>
          </div>
        </div>
      </div>
      {popup && (
        <>
          <div className="backdrop" />
          <div className="popup">
            <h5 className="font-bold text-black text-lg">{popup.subject}</h5>
            <p className="font-semibold text-med-grey tracking-wide mb-3">
              {popup.message}
            </p>
            <button onClick={() => setPopup(false)} className="btn-tertiary">
              Close
            </button>
          </div>
        </>
      )}
    </>
  );
}
